import { Box, Button, Card } from "@mui/material";
import {styled } from "@mui/material/styles";

export const PreviewCard = styled(Card)(({ theme }) => ({
    width: '100%',
    // maxWidth: '768px',
    flex: "0 0 auto",
    // overflow: 'auto',
    // height: '100%',
    boxShadow: '0 10px 25px rgba(0, 0, 0, 0.1)',
  }));
  
  export const SubjectLine = styled(Box)(({ theme }) => ({
    padding: theme.spacing(2),
    backgroundColor: '#f5f5f5',
    borderRadius: theme.spacing(1),
        marginBottom: theme.spacing(3),
    }));
  
  export const ActionButtons = styled(Box)(({ theme }) => ({
    display: 'flex',
    gap: theme.spacing(1),
    marginTop: theme.spacing(2),
    flexWrap: 'wrap',
  }));
  
  export const ActionButton = styled(Button)(({ theme }) => ({
    textTransform: 'none',
    fontSize: '14px',
    padding: theme.spacing(1, 2),
    borderRadius: theme.spacing(1),
    minWidth: '120px',
  }));
  export const EmailBody = styled(Box)(({ theme }) => ({
    padding: theme.spacing(2),
    backgroundColor: '#f5f5f5',
    borderRadius: theme.spacing(1),
    color: '#374151',
    lineHeight: 1.6,
    flex: "1 1 auto",
    overflow: 'auto',
    gap: theme.spacing(2),
  }));